<template v-if="selectedStates.length > 2">
    <v-layout row wrap align-center justify-space-between>
        <v-flex class="handbook-leftDivider_hideSmall">
            <v-btn-toggle v-model="inputVal" class="transparent handbook_toggleButton" :mandatory="true">
                <v-tooltip v-for="state in selectedStates" :key="state.value" top disabled>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="handbook_button state_button" :value="state.value"><span class="long-button-text chamberButton">{{ state.text }}</span>
                        </v-btn>
                    </template>
                </v-tooltip>
                <span></span>
            </v-btn-toggle>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    props: ['value', 'statesOnly', 'states'],
    computed: {
        selectedStates: function() {
            let selectedStates = [            
                { text: 'NSW', value: 'NSW' },
                { text: 'VIC', value: 'VIC' },
                { text: 'QLD', value: 'QLD' },
                { text: 'WA', value: 'WA' },
                { text: 'SA', value: 'SA' },
                { text: 'TAS', value: 'TAS' },
                { text: 'ACT', value: 'ACT' },
                { text: 'NT', value: 'NT' }
            ];
            if (this.states && this.states.length > 0) {
                selectedStates = selectedStates
                .filter(s => this.states
                    .map(s => s.toLowerCase()).includes(s.text.toLowerCase())
                );
            }
            if (!this.statesOnly) {
                selectedStates = [{ text: 'National', value: 'ALL' },...selectedStates];
            }
            return selectedStates
        },
        inputVal: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val);
                this.currentMap = val;
            }
        }
    },
}
</script>
<style scoped>
.handbook_toggleButton {
    flex-wrap: wrap;
}
.state_button {
    max-width: 85px;
}
</style>